<template>
    <div class="riskList">
        <div class="table-box">
            <div class="title">
                <div class="flex justify-start align-center">
                    <div class="icon-box">
                        <i class="iconfont icon-xingxing"></i>
                    </div>
                    <b>星级评定</b>
                </div>
                <div class="page-cancel" @click="$router.go(-1)">
                    <i class="icon iconfont icon-jiantouzuo1"></i>返回
                </div>
            </div>
            <div class="search-flex">
                <div class="search-box">
                    <el-form ref="form" :model="search" class="flex" label-width="80px">
                        <el-form-item label="关键词">
                            <el-input v-model="search.keyword" clearable placeholder="请输入关键词搜索"></el-input>
                        </el-form-item>
                        <el-form-item label="评定时间">
                            <el-date-picker
                                v-model="search.time"
                                class="inp"
                                clearable
                                end-placeholder="请选择"
                                format="yyyy-MM-dd"
                                range-separator="-"
                                start-placeholder="请选择"
                                type="daterange"
                                value-format="yyyy-MM-dd">
                            </el-date-picker>
                        </el-form-item>
                        <el-form-item label="是否参评">
                            <el-select v-model="search.is_can" class="inp" clearable placeholder="请选择">
                                <el-option
                                    v-for="item in isYes"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="评定结果">
                            <el-select v-model="search.star" class="inp" clearable placeholder="请选择">
                                <el-option
                                    v-for="item in evaluateOptions"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-form>
                    <div class="search-btn" @click="searchFun">
                        <i class="iconfont icon-sousuo"></i>搜索
                    </div>
                    <div class="search-btn reset" @click="reset">
                        <i class="iconfont icon-huanxiang"></i>重置
                    </div>
                </div>
            </div>
            <div class="list ">
                <el-table
                    :cell-style="textCenter"
                    :data="tableData"
                    :header-cell-style="centerbgc"
                    border
                    style="width: 100%">
                    <el-table-column
                        label="序号"
                        type="index"
                        width="80">
                    </el-table-column>
                    <el-table-column
                        label="星级评定名称"
                        prop="title">
                    </el-table-column>
                    <el-table-column
                        label="评定时间"
                        width="350">
                        <template slot-scope="scope">
                            {{ scope.row.start_time }} - {{ scope.row.end_time }}
                        </template>
                    </el-table-column>
                    <el-table-column
                        label="参评机构（家）"
                        prop="org_num"
                        width="150">
                    </el-table-column>
                    <el-table-column
                        label="是否参加"
                        width="150">
                        <template slot-scope="scope">
                            {{ scope.row.is_can == 1 ? '是' : '否' }}
                        </template>
                    </el-table-column>
                    <el-table-column
                        label="分数"
                        prop="score"
                        width="150">
                    </el-table-column>
                    <el-table-column
                        label="排名"
                        prop="sort"
                        width="150">
                    </el-table-column>
                    <el-table-column
                        label="星级结果"
                        prop="star"
                        width="150">
                    </el-table-column>
                    <el-table-column
                        label="操作"
                        width="250">
                        <template slot-scope="scope" class="flex" v-if="scope.row.is_can == 1">
                            <div class="edit" @click="look(scope.row)">得分详情</div>
                            <div class="edit" @click="showDialog(scope.row)">查看报告</div>
                        </template>
                    </el-table-column>
                </el-table>
            </div>

            <div class="page-box">
                <el-pagination
                    :current-page.sync="search.page"
                    :page-size="search.limit"
                    :total="search.total"
                    background
                    class="page-all margin-top self-end"
                    layout="prev, pager, next"
                    @current-change="list">
                </el-pagination>
            </div>
        </div>

        <evaluateDialog
            :id="id"
            :oid="log_id"
            :dialogVisible="dialogVisible"
            @handleClose="handleClose"/>
    </div>
</template>
<script>
import {evaluateOptions, isYes, riskLevelOptions} from "@/utils/const";
import evaluateDialog from "@/views/admin/pages/orgDetail/common/evaluateDialog";
import {getEvaluateStarList} from "@/api/admin";

export default {
    name: "evaluateList",
    data() {
        return {
            riskLevelOptions: riskLevelOptions,
            isYes: isYes,
            evaluateOptions: evaluateOptions,
            dialogVisible: false,
            id: '',
          log_id:'',
            oid: '',
            search: {
                keyword: '',
                time: '',
                is_can: '',
                star: '',
                page: 1,
                limit: 10,
                total: 0,
            },
            tableData: []
        }
    },
    components: {evaluateDialog},
    computed: {
        textCenter() {
            return {
                textAlign: 'center'
            }
        },
        centerbgc() {
            return {
                textAlign: 'center',
                background: '#f7f7f7'
            }
        }
    },
    created() {
        this.oid = this.$route.query.oid
        this.$emit("setActive", {
            headActive: 2
        })
        this.list()
    },
    methods: {
        async list() {
            let _data = await getEvaluateStarList(
                this.oid,
                this.search.keyword,
                this.search.time ? this.search.time.join(',') : '',
                this.search.is_can,
                this.search.star,
                this.search.page,
                this.search.limit
            );
            if (_data.status == 200) {
                this.tableData = _data.data.data;
                this.search.total = _data.data.total;
            }
        },

        searchFun() {
            this.search.page = 1
            this.tableData = []
            this.list()
        },

        reset() {
            this.search.keyword = ''
            this.search.time = ''
            this.search.star = ''
            this.search.is_can = ''
            this.searchFun()
        },

        showDialog(row) {
            this.id = row.id
            this.log_id = row.log_id
            this.dialogVisible = true
        },

        look(row) {
            this.id = row.id
            this.$router.push({
                path: '/admin/orgEvaluateDetail',
                query: {
                    id: row.id,
                    oid: row.log_id
                }
            })
        },

        handleClose() {
            this.id = ''
            this.dialogVisible = false
        }
    },
    watch: {},
    filters: {}
}
</script>

<style lang="scss" scoped>
.riskList {
    width: 100%;
    height: 100%;
    min-height: calc(100vh - (173px + 159px));
    background: #f3f5f7;
    padding: 20px;

    .edit {
        display: inline-block;
        margin: 0 15px;
        color: #0089ff;
        cursor: pointer;
    }

    .table-box {
        width: 100%;
        background-image: linear-gradient(0deg,
            #ffffff 84%,
            #edf6ff 100%);
        padding: 0 20px;
        border-radius: 10px;
        min-height: 500px;

        .title {
            display: flex;
            justify-content: space-between;
            align-items: center;
            height: 60px;
            border-bottom: 2px solid #e3e7f0;

            b {
                font-size: 22px;
                color: #16181d;
                font-weight: bold;
                margin-left: 10px;
            }

            .icon-box {
                width: 30px;
                height: 30px;
                background-image: linear-gradient(-30deg,
                    #3579fb 0%,
                    #44a3ff 100%);
                box-shadow: 0px 10px 10px 0px rgba(50, 150, 255, 0.3);
                border-radius: 10px;
                text-align: center;
                line-height: 30px;

                i {
                    font-size: 20px;
                    color: #ffffff;
                }
            }
        }

        .list {
            width: 100%;

            .btn {
                width: 60px;
                height: 26px;
                border-radius: 4px;
                font-size: 14px;
                text-align: center;
                line-height: 26px;
                margin: 0 auto;

                &.gray {
                    color: #8a8a8a;
                    background-color: #f2f2f2;
                }

                &.yellow {
                    color: #fad471;
                    background-color: #fffbdd;
                }

                &.orange {
                    color: #f58739;
                    background-color: #ffeedd;
                }

                &.red {
                    color: #f8001a;
                    background-color: #ffdddd;
                }
            }
        }

        .search-flex {
            width: 100%;
            display: flex;
            justify-content: space-between;
            align-items: center;

            padding: 20px 0;

            .shensu {
                width: 113px;
                height: 37px;
                background-image: linear-gradient(0deg,
                    #f59a23 0%,
                    #feb555 100%);
                border-radius: 4px;
                text-align: center;
                line-height: 37px;
                font-size: 16px;
                color: #ffffff;
                cursor: pointer;

                i {
                    font-size: 20px;
                    margin-right: 5px;
                    color: #ffffff;
                }
            }

            .search-box {
                display: flex;
                justify-content: flex-start;
                align-items: center;

                .search-btn {
                    width: 112px;
                    height: 36px;
                    background-image: linear-gradient(0deg,
                        #2791ff 0%,
                        #81b6ff 100%);
                    border-radius: 4px;
                    text-align: center;
                    line-height: 36px;
                    font-size: 16px;
                    color: #ffffff;
                    margin-left: 15px;
                    cursor: pointer;

                    i {
                        font-size: 20px;
                        margin-right: 5px;
                        color: #ffffff;
                    }

                    &.reset {
                        background-image: none;
                        background-color: #ffffff;
                        border-radius: 4px;
                        border: solid 1px #cccccc;
                        line-height: 34px;
                        color: #333333;

                        i {
                            color: #999999;
                        }
                    }
                }
            }

        }
    }

}
</style>


